import { LS_LANGUAGE } from "../common/constants/storages";

const Language = () => {
    let language = localStorage.getItem(LS_LANGUAGE);
    if (language) {
        return language;
    }
    if (navigator.language) {
        language = navigator.language.substring(0, 2);
    } else if (navigator.languages && navigator.languages.length > 0) {
        language =  navigator.languages[0].substring(0, 2);
    } else { 
        language = 'en'; // Default to English if no language is found
    }
    localStorage.setItem(LS_LANGUAGE, language);
    return language;
}

export default Language;